import React,{useState,useEffect} from "react";
import GoogleMapReact from 'google-map-react';
import axios from "axios";
import avtlogo from "../../img/truck.png";
import {aPIURL,auTHURL} from '../../utils/common';


function CVLocations(props) 
{
  const API_URL=aPIURL();
  const [defaultCenter, setPosts] = useState([]);
  
    useEffect(() => {
      (async () => {

        const IDD = props.device_Id;
        //alert(IDD);
        const daurls=API_URL+`DeviceLog/${IDD}`; 
        //alert(daurls);
        const response = await axios.get(daurls);
        console.log(response);
        const data = response.data.data;
        // data contains all the posts which are successfully logged
        console.log(data);
  
        // Here posts is logged as empty array [].........why?
        setPosts(data);
        console.log("posts are", defaultCenter);
      })();
    }, []);

    // / "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"

    const onMarkerClick = () => 
    {
      //alert('f');
    };
    const renderMarkers = (logDateTime,speed,deviceName,latitude, longitude,map, maps) =>
    {
     let marker = new maps.Marker({
     position: { lat: latitude, lng: longitude},
     map:map,
     icon:avtlogo,
     label : { color: 'black',left: 10,bottom: '-35px',position: 'relative',fontWeight: 'bold', fontSize: '10px', text: deviceName},
     title: 'Device Name: ' +deviceName +'\n'+'Speed: '+speed+' Km/h'+'\n'+'Last Logging: '+logDateTime
     });
     return marker;
    };
    return(<div className="App1">
    {defaultCenter.map((post) => {
      return ( 
      <>
      <span style={{ fontSize:"14px",textAlign:"left"}}>
      <b> Device Name : </b>{post.deviceName} &nbsp;&nbsp;&nbsp;&nbsp;<b>  Speed : </b>{post.speed} Km/h</span><br/>
        <div style={{height: "45vh", width: "100%"}}> 
       <GoogleMapReact
         bootstrapURLKeys={{ key: process.env.REACT_APP_MAPKEY }}
         center={{ lat: post.latitude, lng: post.longitude }}
         defaultZoom={4}
         yesIWantToUseGoogleMapApiInternals
         onGoogleApiLoaded={({ map, maps }) => renderMarkers(post.logDateTime,post.speed,post.deviceName,post.latitude,post.longitude,map, maps)}
       ></GoogleMapReact>
       </div></>
      );
    })}
  </div>);
    {/*
    const renderMarkers = (logDateTime,speed,deviceName,latitude, longitude,map, maps) => 
    {
      
 

     let marker = new maps.Marker({
     position: { lat: latitude, lng: longitude},
     map:map,         
     icon:avtlogo,
     label : { color: '#FFFFFF',left: 10,bottom: '-35px',position: 'relative',fontWeight: 'bold', fontSize: '10px', text: deviceName},
     title: 'Device Name: ' +deviceName +'\n'+'Speed: '+speed+'\n'+'Last Logging: '+logDateTime
          
     
     });
     return marker;
    };
    


    return(<div className="App">
    {defaultCenter.map((post) => {
      return (       
        <div style={{height: "45vh", width: "100%"}}>       
       <GoogleMapReact
         bootstrapURLKeys={{ key: 'AIzaSyC61C3EfSzbCLhe_a271ldG9YrQ0BcQMZE' }}
         center={{ lat: post.latitude, lng: post.longitude }}
         defaultZoom={18}
         yesIWantToUseGoogleMapApiInternals
         onGoogleApiLoaded={({ map, maps }) => renderMarkers(post.deviceName,post.latitude,post.longitude,map, maps)}></GoogleMapReact>       
       </div>
      );
    })}
  </div>);*/}
   
}

export default CVLocations;